<template>
    <div id="wallet-settings">
        <WalletAddBalance v-if="addBalanceModal" @add-balance="addBalanceWhatsapp" @close="addBalanceModal = false" />
        <CreditCardNeeded v-if="creditCardNeededModal" @close="creditCardNeededModal = false" />
        <div class="wallet">
            <div class="whatsapp-wallet">
                <div class="logo">
                    <WalletSVG />
                </div>
                <div class="content">
                    <div class="wallet-info">
                        <div class="title">{{  $t("billing.availableBalance") }}</div>
                        <div class="balance" v-if="wallet.whatsapp">{{ formatPrice(wallet.whatsapp.amount) }}TL</div>
                    </div>
                    <div class="wallet-add" @click="openAddWhatsappBalanceModal">{{  $t("billing.addBalance") }}</div>
                </div>
            </div>
        </div>
        <div class="wallet-logs">
            <div class="title">
                {{ $t("billing.walletLogs")}}
                <div class="pagination">
                    <div>
                        <a-date-picker v-model:value="filters.startDate" :placeholder="$t('message.startDate')" />
                        <a-date-picker v-model:value="filters.endDate" :placeholder="$t('message.endDate')" />
                    </div>
                    <a-select v-model:value="filters.type" class="filters-type">
                        <a-select-option v-for="type of Object.keys(types)" :value="type" :key="type">
                            {{ types[type] }}
                        </a-select-option>
                        <a-select-option :selected="true" :value="''">{{ $t("billing.selectTransactionType") }}</a-select-option>
                    </a-select>
                    <a-select v-model:value="filters.channelId" class="filters-type">
                        <a-select-option v-for="channel of channels" :value="channel._id" :key="channel._id">
                            {{ channel.name }}
                        </a-select-option>
                        <a-select-option :selected="true" :value="''">{{ $t("message.selectChannel") }}</a-select-option>
                    </a-select>
                    <div class="text">
                        <a-input-number
                            v-model="filters.page"
                            :min="1"
                            :max="Math.ceil(totalActivity / filters.perPage)"
                        />/{{ Math.ceil(totalActivity / filters.perPage) }} of
                        {{ totalActivity }}
                    </div>
                    <a-button-group>
                        <a-button class="pagination-button" @click="backwardPage">
                            <div class="material-icons">arrow_back_ios</div>
                        </a-button>
                        <a-button class="pagination-button" @click="forwardPage">
                            <div class="material-icons">arrow_forward_ios</div>
                        </a-button>
                    </a-button-group>
                </div>
            </div>
            <div class="logs">
                <a-table :columns="columns" :data-source="activities" :pagination="false">
                    <p slot="createdAt" slot-scope="record" style="margin: 0">{{ formatDate(record) }}</p>
                    <p slot="type" slot-scope="record, item" style="margin: 0">{{ formatType(record, item) }}</p>
                    <p slot="phoneNumber" slot-scope="record, item" style="margin: 0">
                        {{ getPhoneNumber(item) }}
                    </p>
                    <p slot="country" slot-scope="record, item" style="margin: 0">
                        {{ $_.get(item, "payload.country", "-") }}
                    </p>
                    <p slot="before" slot-scope="record, item" style="margin: 0">
                        <MoneyFormatter :price="item.before.toFixed(4)"></MoneyFormatter>
                    </p>
                    <p slot="after" slot-scope="record, item" style="margin: 0">
                        <MoneyFormatter :price="item.after.toFixed(4)"></MoneyFormatter>
                    </p>
                    <p slot="amount" slot-scope="record, item" style="margin: 0">
                        <MoneyFormatter :price="item.amount.toFixed(4)"></MoneyFormatter>
                    </p>
                </a-table>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import log2 from "../../../../utils/log2";
import WalletSVG from "../components/WalletSVG.vue";
import WalletAddBalance from "../components/WalletAddBalance.vue";
import CreditCardNeeded from "../../../../components/billing/CreditCardNeeded.vue";
import moment from "moment";
import MoneyFormatter from "../../../../components/MoneyFormatter.vue";
import _ from "lodash";
import MiniFilterPreview from "../../Chatbot/pages/archive/MiniFilterPreview.vue";

const log = log2("Settings/WebSiteIntegration");

export default {
    name: "Wallet",
    components: {
        MoneyFormatter,
        WalletSVG,
        WalletAddBalance,
        CreditCardNeeded,
        MiniFilterPreview,
    },
    data: () => ({
        columns: [
            { title: "Tarih", dataIndex: "createdAt", key: "createdAt", scopedSlots: { customRender: "createdAt" } },
            { title: "İşlem Tipi", dataIndex: "type", key: "type", scopedSlots: { customRender: "type" } },
            {
                title: "Numara",
                dataIndex: "phoneNumber",
                key: "phoneNumber",
                scopedSlots: { customRender: "phoneNumber" },
            },
            {
                title: "Ülke",
                dataIndex: "country",
                key: "country",
                scopedSlots: { customRender: "country" },
            },
            { title: "Önceki Bakiye", dataIndex: "before", key: "before", scopedSlots: { customRender: "before" } },
            { title: "Sonraki Bakiye", dataIndex: "after", key: "after", scopedSlots: { customRender: "after" } },
            { title: "Tutar", dataIndex: "amount", key: "amount", scopedSlots: { customRender: "amount" } },
        ],
        addBalanceModal: false,
        creditCardNeededModal: false,
        filters: {
            page: 1,
            perPage: 100,
            type: "",
            startDate: null,
            endDate: null,
            channelId: "",
        },
        types: {
            deposit: "Bakiye Yükleme",
            "credit-usage": "Bakiye Kullanımı",
            "business-marketing": "Marketing",
            "business-utility": "Utility",
            "business-authentication": "Authentication",
            "business-service": "Service",
            "incoming-session-message": "Gelen Mesaj",
            "outgoing-session-message": "Giden Mesaj",
            "free-tier-conversation": "Ücretsiz Konuşma (FTC)",
            "chat-start": "Chat Başlatma",
            message: "Whatsapp Toplu Mesaj",
        },
    }),
    computed: {
        ...mapState({
            wallet: (state) => state.wallet.wallet,
            activities: (state) => state.wallet.activities,
            totalActivity: (state) => state.wallet.totalActivity,
            billingDetail: (state) => state.site.billingDetail,
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            channels: (state) =>
                state.channel.channels.filter((channel) =>
                    ["whatsapp-business-api", "whatsapp-qr", "whatsapp-v2"].includes(channel.type)
                ),
        }),
    },
    methods: {
        ...mapActions({
            getBalance: "wallet/getBalance",
            getActivities: "wallet/getWalletLogs",
            addBalance: "wallet/addBalance",
        }),
        getPhoneNumber(item) {
            const numberDetail = _.get(item, "payload.phoneNumber");
            if (!numberDetail) return "-";
            if (typeof numberDetail === "object") {
                return _.get(numberDetail, "number") || "-";
            } else {
                return numberDetail || "-";
            }
        },
        formatDate(date) {
            return moment(date).format("YYYY/MM/DD HH:mm:ss");
        },
        formatType(type) {
            return this.types[type] || type;
        },
        seperateWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        formatPrice(price) {
            return this.seperateWithCommas(price.toFixed(2));
        },
        openAddWhatsappBalanceModal() {
            if (!this.billingDetail?.binNumber) {
                this.creditCardNeededModal = true;
            } else {
                this.addBalanceModal = true;
            }
        },
        addBalanceWhatsapp(price) {
            this.addBalance({
                walletType: "whatsapp",
                amount: price,
            })
                .then(() => {
                    this.addBalanceModal = false;
                    this.$toasted.success(`Whatsapp hesap bakiyenize ${price}TL Bakiye eklenmiştir`, {
                        duration: 3000,
                        position: "top-center",
                    });
                })
                .catch(() => {
                    this.$message.error({
                        content: "Hesabınıza bakiye eklenemedi.",
                        key: "markpaid",
                        duration: 3,
                    });
                });
        },
        getWalletActivities() {
            this.getActivities(this.filters);
        },
        backwardPage() {
            if (this.filters.page <= 1) return;
            this.filters.page = this.filters.page - 1;
        },
        forwardPage() {
            if (Math.ceil(this.totalActivity / this.filters.perPage) <= this.filters.page) return;
            this.filters.page = this.filters.page + 1;
        },
    },
    mounted() {
        this.getWalletActivities();
    },
    watch: {
        filters: {
            deep: true,
            handler() {
                this.getWalletActivities();
            },
        },
    },
};
</script>
<style lang="scss">
#wallet-settings {
    .pagination {
        .ant-input-number {
            width: 50px;
            .ant-input-number-handler-wrap {
                display: none;
            }
        }
    }
    .ant-table-body {
        border: 1px solid #e8e8e8;
    }

    .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
        background-color: #fff4de !important;
    }

    .ant-table-thead > tr > th {
        background-color: transparent !important;
    }

    tr.ant-table-expanded-row {
        background-color: transparent !important;
    }

    .ant-table-row-expand-icon {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ant-table-row-expand-icon:focus,
    .ant-table-row-expand-icon:hover {
        color: #ffa800 !important;
        background-color: #fff4de !important;
    }

    .ant-btn:hover,
    .ant-btn:focus {
        color: #ffa800 !important;
        border-color: #ffa800;
    }

    .ant-table-tbody {
        tr > td {
            padding: 3px;
            font-size: smaller;
        }
    }
}
</style>
<style scoped lang="scss">
#wallet-settings {
    .filters-type {
        min-width: 200px;
    }

    .wallet {
        .whatsapp-wallet {
            background-color: #fff4de;
            padding: 20px;
            border-radius: 4px;
            border: 1px solid #ffa800;
            display: flex;
            align-items: center;
            gap: 15px;

            .logo {
                svg {
                    width: 65px;
                    height: 65px;
                }
            }

            .content {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;

                .title {
                    font-size: 22px;
                    font-weight: bold;
                    color: #ffa800;
                }

                .balance {
                    font-size: 28px;
                    font-weight: bold;
                    color: #3f3d56;
                }

                .wallet-add {
                    cursor: pointer;
                    font-size: 16px;
                    background-color: #ffa800;
                    font-weight: bold;
                    color: #3f3d56;
                    padding: 10px 25px;
                    border-radius: 40px;
                }
            }
        }
    }

    .wallet-logs {
        margin-top: 50px;

        .title {
            font-size: 22px;
            font-weight: bolder;
            color: #3f3d56;
            text-transform: uppercase;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .pagination {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 15px;

                .text {
                    font-size: 16px;
                    margin-right: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 5px;
                }

                .pagination-button {
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .material-icons {
                        font-size: 16px;
                    }
                }
            }
        }

        .logs {
            margin-top: 20px;
        }
    }
}
</style>
